'use strict';

require('./index.scss');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _hfReactHelper = require('common/utils/hf-react-helper');

var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);

var _pricingLevelFeature = require('../pricing-level-feature');

var _pricingLevelFeature2 = _interopRequireDefault(_pricingLevelFeature);

var _contactUsButton = require('../contact-us-button');

var _contactUsButton2 = _interopRequireDefault(_contactUsButton);

var _pricingIconPhone2x = require('../pricing-icon-phone@2x.png');

var _pricingIconPhone2x2 = _interopRequireDefault(_pricingIconPhone2x);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var CorporatePricingLevel = _react2['default'].createClass({
    displayName: 'CorporatePricingLevel',
    getInitialState: function getInitialState() {
        return { expanded: false };
    },
    getDefaultProps: function getDefaultProps() {
        return {
            'corpLevelName': 'Enterprise'
        };
    },
    onLevelClick: function onLevelClick() {
        this.setState({ expanded: !this.state.expanded });
    },
    render: function render() {
        var bodyClasses = (0, _classnames2['default'])({
            'm-pricing-level--body': true,
            'small-12': true,
            'columns': true,
            'expanded': this.state.expanded
        });
        var levelClasses = (0, _classnames2['default'])({
            'small-6': true,
            'medium-4': true,
            'medium-offset-1': true,
            'large-12': true,
            'large-offset-0': true,
            'columns': true,
            'level-title': true
        });
        var arrowContainerClasses = (0, _classnames2['default'])({
            'arrow-container': true,
            'hide-for-large-up': true,
            'hide-for-small': true,
            'small-2': true,
            'medium-1': true,
            'columns': true
        });
        var arrowClasses = (0, _classnames2['default'])({
            'l-vertical-align': true,
            'arrow': true,
            'expanded': this.state.expanded
        });
        var contactUsClasses = (0, _classnames2['default'])({
            'phone-container': true,
            'hide-for-large-up': true,
            'small-6': true,
            'medium-5': true,
            'medium-offset-1': true,
            'columns': true,
            'level-price': true
        });
        var lookingForMoreClasses = (0, _classnames2['default'])({
            'm-pricing-level--body': true,
            'small-10': true,
            'small-centered': true,
            'columns': true,
            'looking-for-more': true,
            'l-padding-t-50': this.props.coupon && this.props.coupon !== null
        });

        var mainFeature = '';
        var noFeatures = true;
        if (this.props.corporateFeatures && this.props.corporateFeatures.main_feature) {
            var name = this.props.corporateFeatures.main_feature.name ? this.props.corporateFeatures.main_feature.name : name;
            var detail = this.props.corporateFeatures.main_feature.detail ? this.props.corporateFeatures.main_feature.detail : null;
            var number = this.props.corporateFeatures.main_feature.number ? this.props.corporateFeatures.main_feature.number : null;
            mainFeature = _react2['default'].createElement(_pricingLevelFeature2['default'], { name: name, planName: this.props.name, detail: detail, number: number, key: 'main-feature', expanded: this.state.expanded });
            noFeatures = false;
        }

        var features = '';
        if (this.props.corporateFeatures && this.props.corporateFeatures.features) {
            features = this.props.corporateFeatures.features.map(function (feature, i) {
                var name = feature.name ? feature.name : name;
                var detail = feature.detail ? feature.detail : null;
                var number = feature.number ? feature.number : null;
                return _react2['default'].createElement(_pricingLevelFeature2['default'], { name: name, planName: this.props.name, detail: detail, number: number, key: 'feature' + i, expanded: this.state.expanded });
            }.bind(this));
        }

        var phoneNumberClasses = (0, _classnames2['default'])({
            'contact-us-phone-number': true,
            'l-nowrap': true,
            'no-features-padding': noFeatures
        });
        var corpLevelColumnClasses = (0, _classnames2['default'])({
            'm-pricing-level': true,
            'small-12': true,
            'medium-12': true,
            'large-3': this.props.totalColumns >= 3,
            'large-4': this.props.totalColumns == 2,
            'large-6': this.props.totalColumns == 1,
            'columns': true,
            'end': true,
            'corporate-pricing-level': true
        });
        return _react2['default'].createElement(
            'div',
            { className: corpLevelColumnClasses },
            _react2['default'].createElement(
                'div',
                { className: 'm-pricing-level--header small-12 columns block', onClick: this.onLevelClick },
                _react2['default'].createElement(
                    'div',
                    { className: levelClasses },
                    _react2['default'].createElement(
                        'div',
                        { className: 'level-title l-vertical-align-wrapper' },
                        _react2['default'].createElement(
                            'div',
                            { className: 'l-vertical-align' },
                            this.props.corpLevelName.toUpperCase()
                        )
                    )
                ),
                _react2['default'].createElement(
                    'div',
                    { className: contactUsClasses },
                    _react2['default'].createElement(
                        'div',
                        { className: 'phone-container l-vertical-align-wrapper' },
                        !this.state.expanded && _react2['default'].createElement(_contactUsButton2['default'], {
                            timePeriod: this.state.timePeriod,
                            pricingSource: this.props.pricingSource,
                            onClick: function onClick(e) {
                                return e.stopPropagation();
                            }
                        })
                    )
                ),
                _react2['default'].createElement(
                    'div',
                    { className: arrowContainerClasses },
                    _react2['default'].createElement(
                        'div',
                        { className: 'level-title l-vertical-align-wrapper' },
                        _react2['default'].createElement(
                            'div',
                            { className: arrowClasses },
                            '\xA0'
                        )
                    )
                )
            ),
            _react2['default'].createElement(
                'div',
                { className: bodyClasses },
                _react2['default'].createElement(
                    'div',
                    { className: 'first-section block' },
                    _react2['default'].createElement(
                        'div',
                        { className: lookingForMoreClasses },
                        'Looking for more?'
                    ),
                    _react2['default'].createElement(
                        'div',
                        { className: 'block' },
                        _react2['default'].createElement(_contactUsButton2['default'], { timePeriod: this.state.timePeriod, pricingSource: this.props.pricingSource })
                    ),
                    mainFeature
                )
            ),
            features
        );
    }
});

module.exports = CorporatePricingLevel;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/pricing/corporate-pricing-level/index.jsx
 ** module id = 1066
 ** module chunks = 0
 **/